import { api } from './client'

export async function startWeeklyReview(periodStart: string): Promise<string> {
  const { id } = await api.post<{ id: string }>('/api/weekly-reviews', { periodStart })
  return id
}

export function completeWeeklyReview(id: string): Promise<void> {
  return api.post(`/api/weekly-reviews/${id}/complete`)
}
